import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import { Button } from "@material-ui/core";
import "./homedialogue.css";
import { USER_TOUR_HIDE } from '../../../constants/userConstants';
import { useDispatch, useSelector } from 'react-redux';

function HomeDialogues() {
  const dispatch = useDispatch()
  const [dialog, setDialog] = useState(false);

  const userLogin = useSelector(state => state.userLogin);
  const { userInfo } = userLogin;

  const userTour = useSelector(state => state.userTour);
  const { tourData } = userTour;

  useEffect(() => {
    if (tourData) {
      setDialog(true);
    } else {
      setDialog(false);
    }
  }, [tourData])

  const handleSkip = () => {
    setDialog(false);
    dispatch({ type: USER_TOUR_HIDE })
  }

  return (
    <>
      <Dialog
        PaperProps={{ style: { minWidth: "270px", padding: "2rem" } }}
        maxWidth="md"
        open={dialog}
      >
        <h2 style={{ textAlign: "center", color: "#336d8b" }}>
          Dear {userInfo?.user.name}, Welcome to WellWritten.Ai{" "}
        </h2>
        <p
          style={{
            textAlign: "center",
            color: "#336d8b",
            marginTop:"1rem",
            marginBottom: "1.5rem",
          }}
        >
          We'd love to give you a brief tour and explain how WellWritten.Ai
          works!
        </p>
        <div className="welcome_dialogue__buttons">
          <Button
            onClick={handleSkip}
            disableRipple={true}
            disableFocusRipple={true}
            variant="outlined"
            size="small"
            className="hover__backgroundchange__buttons"
          >
            Take Tour
          </Button>
        </div>
        <div className="welcome_dialogue__buttons">
          <p style={{ color: "#f68a06", cursor: "pointer" }} onClick={handleSkip}>Skip</p>
        </div>
      </Dialog>
    </>
  );
}

export default HomeDialogues;
